import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import ArrowIcon from '../components/svgs/arrow-right'
import './ricercatore.sass'

import Lightbox from 'react-images'

export default class RicercatorePage extends Component {
  state = {
    photoIndex: 0,
    isOpen: false,
  }

  render() {
    const { pathContext } = this.props
    const { isOpen } = this.state
    const linkPrefix = pathContext.locale === 'it' ? '' : '/en'

    return (
      <div className="Ricercatore wrap-narrower">
        <h1 className="text-primary">{pathContext.titolo}</h1>
        {/* <p className="text-bold">Sottotitolo</p> */}

        <div className="Ricercatore__Body mt-4">
          <div className="Ricercatore__Body__Left with-arrow-icon">
            <Link
              className="Ricercatore__Arrow"
              to={`${linkPrefix}/gruppo-di-ricerca`}
            >
              <ArrowIcon className="Ricercatore__Arrow" />
            </Link>
            <div className="Ricercatore__Body__Text text-size-1-2">
              {pathContext.contenuto.map(block => (
                <div key={block.id}>
                  {block.model.apiKey === 'testo' && (
                    <div
                      className="text-size-1-2"
                      dangerouslySetInnerHTML={{ __html: block.testo }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {isOpen && (
          <Lightbox
            images={[{ src: pathContext.immagine.fluid.src }]}
            isOpen={isOpen}
            onClose={() => this.setState({ isOpen: false })}
            backdropClosesModal
            showImageCount={false}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/templates/ricercatore.js